import {
  LOG_IN,
  FETCH_ACCOUNT,
  UPDATE_ACCOUNT,
  LOGIN_ERROR,
  CLEAR_ACCOUNT,
  WAITING_LOG_IN,
  FETCH_REQUEST_PASSWORD_RESET,
  UPDATE_REQUEST_PASSWORD_RESET,
  CLEAR_PASSWORD_RESET,
  FETCH_VERIFY_PASSWORD_RESET_TOKEN,
  UPDATE_VERIFY_PASSWORD_RESET_TOKEN,
  FETCH_CHANGE_PASSWORD,
  UPDATE_CHANGE_PASSWORD,
  CLEAR_CHANGE_PASSWORD,
} from "../actions/user";

const userInitialState = {
  loginStatus: "FETCHING",
  passwordResetStatus: null,
  passwordReset: null,
  permissions: [],
};

// NOTE: We deliberately don't ...spread over state here to more tightly
// manage the user part of the store. Bugs here could lead to unauthenticated
// access.
const userReducer = (state = userInitialState, action) => {
  switch (action.type) {
    case "LOGOUT_STORE":
      return {
        ...userInitialState,
        loginStatus: "WAITING_LOG_IN",
      };
    case LOG_IN:
    case FETCH_ACCOUNT:
      return {
        loginStatus: "FETCHING",
        passwordReset: null,
        permissions: [],
      };
    case UPDATE_ACCOUNT:
      return {
        passwordReset: null,
        loginStatus: "LOGGED_IN",
        permissions: action.payload.permissions,
      };
    case LOGIN_ERROR:
      return {
        passwordReset: null,
        loginStatus: "ERROR",
        permissions: [],
      };
    case CLEAR_ACCOUNT:
      return {
        passwordReset: null,
        loginStatus: "LOGGED_OUT",
        permissions: [],
      };
    case WAITING_LOG_IN:
      return {
        passwordReset: null,
        permissions: [],
        loginStatus: "WAITING_LOG_IN",
      };
    case FETCH_REQUEST_PASSWORD_RESET:
      return {
        ...state,
        passwordReset: {
          status: "FETCHING",
          message: null,
        },
      };

    case UPDATE_REQUEST_PASSWORD_RESET:
      return {
        ...state,
        passwordReset: {
          status: action.payload.status,
          message: action.payload.message,
        },
      };

    case CLEAR_PASSWORD_RESET:
      return {
        ...userInitialState,
        passwordReset: null,
      };

    case FETCH_VERIFY_PASSWORD_RESET_TOKEN:
      return {
        ...state,
        passwordReset: {
          status: "FETCHING",
          message: null,
        },
      };

    case UPDATE_VERIFY_PASSWORD_RESET_TOKEN:
      return {
        ...state,
        passwordReset: {
          status: action.payload.status,
          message: null,
          tokenValid: action.payload.tokenValid,
        },
      };

    case FETCH_CHANGE_PASSWORD:
      return {
        ...state,
        passwordReset: {
          status: "FETCHING",
          message: null,
          tokenValid: state.passwordReset.tokenValid,
        },
      };

    case UPDATE_CHANGE_PASSWORD:
      console.log(action.payload);
      return {
        ...state,
        passwordReset: {
          status:
            action.payload.status === "error" ? "ERROR" : "PASSWORD_RESET",
          message: action.payload.message,
          tokenValid: state.passwordReset.tokenValid,
        },
      };

    case CLEAR_CHANGE_PASSWORD:
      return {
        ...state,
        passwordReset: {
          status: "OK",
          message: null,
          tokenValid: true,
        },
      };

    default:
      return state;
  }
};

export default userReducer;



// WEBPACK FOOTER //
// ./src/redux/reducers/user.js